<template>
  <v-app>
    <AppBar />
    <v-main class="custom-row">
      <toast position="ne" />
      <v-container fluid class="full-height">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-badge
      v-if="msgs.length > 0"
      bordered
      :color="errorForBadge ? 'error' : 'success'"
      class="mx-4"
      overlap
    >
      <template v-slot:badge>
        <span>{{ percentage.length }}</span>
      </template>
      <manager-upload />
    </v-badge>
  </v-app>
</template>

<script>
import { Toast } from "vuex-toast";
import { mapState } from "vuex";
import ManagerUpload from "@/components/layout/ManagerUpload.vue";
import AppBar from "@/components/layout/AppBar.vue";

export default {
  name: "App",
  components: {
    Toast,
    ManagerUpload,
    AppBar
  },
  data: () => ({
    title: "Prismian",
    configurationOptions: {
      signInConfig: {
        isSignUpDisplayed: false,
      },
    },
  }),
  computed: {
    ...mapState({
      uploadContainer: (state) => state.uploadContainer,
      percentage: (state) => state.percentage,
      msgs: (state) => state.msgs,
      errorForBadge: (state) => state.errorForBadge,
    }),
  },
  async created() {
    await this.$store.dispatch("setCredentials");
    await this.$store.dispatch("refreshToken");
    await this.$store.dispatch("getMeAction");
  },
  methods: {
    switchDrawer() {
      this.drawer = !this.drawer;
    },
  },
};
</script>

<style scoped>
.max-width {
  width: 100%;
}
.full-height {
  height: 100%;
  overflow: hidden;
  position: fixed;
}
.custom-row {
  height: calc(100% - 15em);
}
</style>
